import { createContext, FC, useContext } from "react";

import { DropdownVariant } from "../types";

type DropdownContextType = {
  allowIcons: boolean;
  hasError: boolean;
  hasSelectedOption?: boolean;
  variant: DropdownVariant;
  optionsClassName?: string;
};

const DropdownContext = createContext<DropdownContextType>({
  allowIcons: false,
  hasError: false,
  hasSelectedOption: undefined,
  variant: "DEFAULT",
});

export const DropdownContextProvider: FC<DropdownContextType> = ({
  children,
  ...rest
}) => (
  <DropdownContext.Provider value={{ ...rest }}>
    {children}
  </DropdownContext.Provider>
);

export const useDropdownContext = () => useContext(DropdownContext);
